// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.6.0",
  date: "2026-08-20T06:51:00.157Z",
  gitInfo: {
    dirty: false,
    raw: "d2922f94e",
    hash: "d2922f94e",
    distance: null,
    tag: null,
    semver: null,
    suffix: "d2922f94e",
    semverString: null
  }
};
/* tslint:enable */
